import { Component, Input, OnInit } from '@angular/core';

import { EmployeeService } from 'src/app/pages/employee/services/employee.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-download-attachment-modal',
  templateUrl: './download-attachment-modal.component.html',
  styleUrls: ['./download-attachment-modal.component.css']
})
export class DownloadAttachmentModalComponent implements OnInit {
  @Input() data: { [key: string]: any }
  @Input() plan: { [key: string]: any }
  formData: { [key: string]: any } = {};
  TypeAttachments: { [key: string]: any } = {};
  PlanAttachments: { [key: string]: any } = {};
  loading: boolean = true;

  constructor(private employeeService: EmployeeService, private ngbActiveModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.getAttachments();
  }

  getAttachments() {
    this.employeeService.getPlanAttachments(this.plan.BenefitType, '').then((response: any) => {
      this.TypeAttachments[this.plan.BenefitType] = response;
      this.employeeService.getPlanAttachments('', this.plan.PlanUniqueAttchID).then((response: any) => {
        this.PlanAttachments[this.plan.BenefitCode] = response;
        this.loading = false;
      });
    });
  }

  closeClicked() {
    this.ngbActiveModal.dismiss();
  }

}
